export class CustomerConsentModel {
    applicationId: number;
    consentId: number;
    name: string;
    value: any;
    consentText: string;
    consentDate: Date = new Date();
    consentLocation?: string;
}
